import { render, staticRenderFns } from "./MyFolderPagination2.vue?vue&type=template&id=1fb20154&"
import script from "./MyFolderPagination2.vue?vue&type=script&lang=ts&"
export * from "./MyFolderPagination2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports